
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="1000px"
      transition="dialog-transition"
      style="border-radius: 40px;"
    >
      <base-card>
        <template slot="title">
          <span class="text-capitalize pa-3 font-weight-bold">
            {{ $tc('employees.edit')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="employeeForm" :disabled="!is_editing" v-if="!loading" class="px-3">
            <div class="black--text">
              {{ $t('employees.main_data_form_label') }}
            </div>

            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="12" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.full_name_form_label')"
                  v-model="one_employee.name"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.cpf_form_label')"
                  v-model="one_employee.cpf"
                  :rules="cpf"
                  v-mask='"###.###.###-##"'
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.cau_form_label')"
                  v-model="one_employee.cau"
                  :rules="required"
                ></v-text-field>
              </v-col>
              
            </v-row>

            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="6" md="4" v-if="one_employee.document_kind == 'cpf'">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.rg_form_label')"
                  v-model="one_employee.rg"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.phone_form_label')"
                  v-model="one_employee.phone"
                  :rules="required"
                  v-mask='((one_employee.phone && one_employee.phone.length) < 15) ? "(##) ####-####" : "(##) # ####-####"'
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.email_form_label')"
                  v-model="one_employee.email"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.rg_form_label')"
                  v-model="one_employee.rg"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.occupation_form_label')"
                  v-model="one_employee.occupation"
                  :rules="required"
                ></v-text-field>
              </v-col>

              
              <v-col class="py-0" cols="12" sm="6" md="4">
                <vc-date-picker v-model="one_employee.birthdate">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$t('employees.birthdate_form_label')"
                      :value="one_employee.birthdate && $dayjs(one_employee.birthdate).format('DD/MM/YYYY') || ''"
                      :rules="required"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <vc-date-picker v-model="one_employee.hired_date">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$t('employees.hired_date_form_label')"
                      :value="one_employee.hired_date && $dayjs(one_employee.hired_date).format('DD/MM/YYYY') || ''"
                      :rules="required"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <vc-date-picker v-model="one_employee.fired_date">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$t('employees.fired_date_form_label')"
                      :value="one_employee.fired_date && $dayjs(one_employee.fired_date).format('DD/MM/YYYY') || ''"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
            </v-row>

            <div class="black--text my-3">
              {{ $t('employees.address_form_label') }}
            </div>

            <address-form ref="address_form" :validate_form="true" :address="one_employee.address"></address-form>

            <div class="black--text my-3">
              {{ $t('employees.bank_account_form_label') }}
            </div>


            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.bank_form_label')"
                  v-model="one_employee.bank"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.agency_form_label')"
                  v-model="one_employee.agency"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.account_form_label')"
                  v-model="one_employee.account"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.pix_form_label')"
                  v-model="one_employee.pix"
                  :rules="required"
                ></v-text-field>
              </v-col>
              
            </v-row>


            <div class="black--text my-3">
              {{ $t('employees.bank_account_form_label') }}
            </div>

            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-select rounded outlined dense class="rounder" 
                  :label="$t('employees.role_form_label')"
                  v-model="one_employee.role_ids"
                  :rules="required"
                  :items="roles"
                  item-text="translated"
                  item-value="id"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </template>


        <template slot="actions">
          <template v-if="is_editing">
            <v-btn small color="error" class="font-weight-bold" @click="cancelEmployee" text>{{ $t('cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn small color="primary" class="font-weight-bold" @click="saveEmployee" text>{{ $t('save') }}</v-btn>
          </template>
          <template v-if="!is_editing">
            <v-spacer></v-spacer>
            <v-btn small color="primary" class="font-weight-bold" :disabled="!$can('update', 'Employee')" @click="is_editing = true" text>{{ $t('edit') }}</v-btn>
          </template>
        </template>

      </base-card>
    </v-dialog>

    <dialog-loading v-if="saving" loadingText="saving" ></dialog-loading>
    <dialog-loading v-if="loading" loadingText="loading" ></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import AddressForm from '../shared/forms/AddressForm.vue';

export default {
  name: 'DialogEditEmployee',
  mixins: [ validations ],
  components: {
    AddressForm
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,

      is_editing: false,

      loading: false,
      saving: false,
      
      one_employee: {
        id: null,
        name: null,
        cpf: null,
        status: 'active',
        // json_attributes
        phone: null,
        rg: null,
        email: null,
        bank: null,
        agency: null,
        account: null,
        pix: null,
        occupation: null,
        birthdate: null,
        hired_date: null,
        fired_date: null,

        address: {
          street: null,
          number: null,
          district: null,
          city: null,
          state: null,
          zip: null,
          complement: null,
        },

        company_id: null,
        role_ids: [],
      },

      loading_roles: false,
      roles: [],
      occupations: []
    }
  },
  methods: {
    cancelEmployee(){
      this.is_editing=false
    },

    getRoles(){
      this.loading_roles = true
      Api.Role.index().then(r=> {
        this.roles = [...r.data.map(d=> {
          let translated = this.$t(`employees.roles.${d.name}`)
          return {...d, translated}
        })]
        this.occupations = [...this.roles]
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        this.loading_roles = false
      })
    },
    getEmployee(){
      this.loading = true
      Api.Employee.show(this.$route.params.id).then(r=> r.data).then(d=> {
        const {json_attributes, user_id, role_ids, emp_id, ...employee} = d
        this.one_employee = {
          ...employee,
          role_ids: role_ids[0],
          id: emp_id,
          user_id,
          ...json_attributes
        }
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        setTimeout(() => {
          this.loading = false
        }, 1200);
      })
    },

    prepareEmployee(){
      let {status, id, user_id, company_id, role_ids, ...user} = this.one_employee

      let user_attributes = {
        ...user,
        id: user_id,
        // password: '1029#azo$app',
        // password_confirmation: '1029#azo$app',
        // name: null,
        // cpf: null,
        // phone: null,
        // rg: null,
        // email: null,
        // bank: null,
        // agency: null,
        // account: null,
        // pix: null,
        // occupation: null,
        // birthdate: null,
        // hired_date: null,
        // fired_date: null,

        // address: {
        //   street: null,
        //   number: null,
        //   district: null,
        //   city: null,
        //   state: null,
        //   zip: null,
        //   complement: null,
        // },
      }
      
      let obj = {
        user_attributes,
        status, 
        role_ids: [role_ids].flat(), 
        company_id, 
        id,
      }
      return obj 
    },
    saveEmployee(){
      if (this.$refs.employeeForm.validate()){
        this.saving = true
        let emp = this.prepareEmployee()
        Api.Employee.update(emp).then(r=> {
          this.$router.go(-1)
        }).catch(err=> {
          console.log({err});
        }).finally(()=>{
          this.saving = false
        })
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getEmployee();
    this.getRoles()
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
  
      } else if (nv == false){
        this.$router.go(-1)
      }
    }
  },
}
</script>

<style scoped>

</style>